import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    width: "80%",
    maxWidth: 320,
  },
  title: {
    fontSize: "0.8125rem",
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
  textField: {
    marginBottom: theme.spacing(1),
  },
  inputBackgroundColor: {
    backgroundColor: "#fff",
  },
  formHelperText: {
    marginLeft: 0,
  },
  forgotPasswordText: {
    color: "#fff",
    cursor: "pointer",
    position: "absolute",
    bottom: -11,
    right: 0,
    fontSize: "11px",
    fontWeight: "bold",
  },
  buttonRoot: {
    width: "89px",
    height: "40px",
    marginTop: theme.spacing(3),
  },
  AdornmentButton: {
    marginRight: theme.spacing(-1),
  },
}))

export default styles
